import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--course-completion-test-corrections-correction-form"
export default class extends Controller {
  static targets = ['teacherSelect', 'submitButton']
  static values = {
    teacherId: String
  }

  connect() {
    this.changeButtonDisabled();
  }

  changeButtonDisabled() {
    const notChangedTeacher = this.teacherIdValue === this.teacherSelectTarget.value;

    this.submitButtonTarget.disabled = notChangedTeacher;
  }
}
